import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { WelcomeLoadingScreen } from '../common/feedback/WelcomeLoadingScreen';

export const SignInPrompt: React.FC = () => {
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    const initiateLogin = async () => {
      try {
        if (inProgress === 'none') {
          await instance.loginRedirect({ scopes: ['profile'] });
        }
      } catch (error) {
        console.error('Login initiation failed:', error);
      }
    };

    const timer = setTimeout(initiateLogin, 100);
    return () => clearTimeout(timer);
  }, [instance, inProgress]);

  return (
    <WelcomeLoadingScreen 
      loadingText={inProgress === 'logout' ? 'Signing out' : 'Signing in'}
    />
  );
};
